/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

import quickbooksConnectDefault from 'src/assets/images/quickbooks/C2QB_green_btn_med_default.svg'
import quickbooksConnectHover from 'src/assets/images/quickbooks/C2QB_green_btn_med_hover.svg'
import {
  AccountingAccessCredentials,
  appendCredentials,
} from 'src/helpers/accounting-access/accounting-access'

type IComponentProps = {
  merchantId: string
  credentials: AccountingAccessCredentials
}

const US_API_HOST = 'https://us.api.lopay.com/api/1/'

const QuickbooksConnectButton: React.FC<IComponentProps> = ({
  merchantId,
  credentials,
}) => {
  const [isHover, setIsHover] = React.useState<boolean>(false)
  const connectOnClick = React.useCallback(() => {
    const apiHost = window.location.host.startsWith('us.')
      ? US_API_HOST
      : import.meta.env.VITE_API_HOST
    const consentUrl = appendCredentials(
      new URL(`merchant/${merchantId}/quickbooks/connect`, apiHost),
      credentials,
    )

    window.location.href = consentUrl.toString()
  }, [merchantId, credentials])

  return (
    <a
      href="#"
      onClick={connectOnClick}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {isHover ? (
        <img src={quickbooksConnectHover} alt="Connect to QuickBooks" />
      ) : (
        <img src={quickbooksConnectDefault} alt="Connect to QuickBooks" />
      )}
    </a>
  )
}

export default QuickbooksConnectButton
